import { render, staticRenderFns } from "./PurchaseOrderFormSaveAndSendDrawer.vue?vue&type=template&id=2b8f7bf0&scoped=true"
import script from "./PurchaseOrderFormSaveAndSendDrawer.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderFormSaveAndSendDrawer.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderFormSaveAndSendDrawer.vue?vue&type=style&index=0&id=2b8f7bf0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8f7bf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b8f7bf0')) {
      api.createRecord('2b8f7bf0', component.options)
    } else {
      api.reload('2b8f7bf0', component.options)
    }
    module.hot.accept("./PurchaseOrderFormSaveAndSendDrawer.vue?vue&type=template&id=2b8f7bf0&scoped=true", function () {
      api.rerender('2b8f7bf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchase-orders/PurchaseOrderFormSaveAndSendDrawer.vue"
export default component.exports